import * as React from 'react';
import { AppSession, LibrarySession } from 'src/models/AppSession';
import { Book } from 'src/models/Book';
import { Migration } from 'src/models/Migration';

export const BookContext = React.createContext<Book | null>(null);
export const MigrationContext = React.createContext<Migration | null>(null);
export const AppContext = React.createContext<AppSession>(AppSession.current);
export const LibraryContext = React.createContext<LibrarySession | null>(null); 